import { Textarea } from "@/components/TextArea";
import { type Control } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../Form";

interface IController {
  control: Control<any>;
  name: string;
  label?: string;
  placeholder?: string;
  description?: string;
  rows?: number;
}
const TextAreaController = (props: IController) => {
  const { control, name, label, placeholder, description, rows } = props;
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        field.value = field.value || "";
        return (
          <FormItem>
            {label ? <FormLabel>{label}</FormLabel> : null}
            <FormControl>
              <Textarea
                {...field}
                placeholder={placeholder}
                className="resize-none"
                rows={rows}
              />
            </FormControl>
            {description ? (
              <FormDescription>{description}</FormDescription>
            ) : null}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export default TextAreaController;
